if(typeof recommend_Title !== 'undefined' && recommend_Title != ''){
  $('h2.trending-title').text(recommend_Title);
}
if(typeof recommend_CollectionId !== 'undefined' && recommend_CollectionId > 0){
  aiRecomInput = [
    {
      indexName: 'ntb_en_products',
      maxRecommendations: 5,
      facetName: "collection_ids",
      facetValue: recommend_CollectionId
    },
  ]
} else {
  aiRecomInput = [
    {
      indexName: 'ntb_en_products',
      maxRecommendations: 5
    },
  ]
}
async function loadRecomTrending(aiRecomParam) {
  let aiRecomLoadUrl = main_globlang_pref + '/pages/contact/' + aiRecomParam + '/?sections=product-loader';
  let aiRecomAppend = await fetch(aiRecomLoadUrl).then(response => response.json()).then(data => { 
    $('.trending-products-container').html(data["product-loader"]);
  });
}
function procRecomTrending(aiRecomResult){
  let aiRecomParam = '';
  $.each(aiRecomResult, function(index,aiRecomItem){
    if(aiRecomItem['handle']){
      aiRecomItemHandle = aiRecomItem['handle'].replaceAll('/', '-');
      aiRecomParam += aiRecomItemHandle + '_';
    }
  });
  loadRecomTrending(aiRecomParam);
}
function hideRecomTrending(){
  $('.recommend-trending-container').addClass('inactive');
}
function initRecomTrending(){
  $.getScript('https://cdn.jsdelivr.net/npm/@algolia/recommend@4.20.0/dist/recommend.umd.min.js', function() {
    const aiRecom = window['@algolia/recommend'];
    const aiRecomClient = aiRecom('K4GLX02XDN', '8990032a777c331ea8907b1e4fe6f034');
    aiRecomClient.getTrendingItems(aiRecomInput).then(({ results }) => {
      if(results && results[0] && results[0].hits && results[0].hits.length > 0){
        procRecomTrending(results[0].hits);
      } else {
        hideRecomTrending();
      }
    }).catch(err => {
        console.log(err);
    });
  });
}
if(Shopify.designMode) {
  console.log('Recommended not loaded in Theme Editor');
} else {
  initRecomTrending();
}
$(document).on('click', '.cart-template .ais-collection-product a.ais-hit--hover', function (event) {
    event.preventDefault();
    if($(this).attr('data-quickshop') == undefined){
      var recomprodlink = $(this).attr('href');
      $(this).attr('data-quickshop', recomprodlink+'?view=quickshop');
      $(this).trigger("click");
    }
});